import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import toast from 'react-hot-toast';
import { deleteCustomer } from '../../service/customerService';

const DeleteModal = ({ show, handleClose, customer, admin, setCustomers }) => {

  const [isLoading, setIsLoading] = useState(false);

  const deleteCustomerHandler = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      const { status } = await deleteCustomer(customer.companyName);
      if (status === 201) {
        toast.success(`${customer.companyName} حذف شد`)
        setCustomers(prev => {
          let allItems = [...prev];
          let newItems = allItems.filter(item => item.companyName !== customer.companyName);
          return [...newItems]
        })
        handleClose();
      }

    } catch (err) {
      if (err.response && err.response.status === 404) {
        toast.error('کاربر یافت نشد')

      }
      else {
        toast.error('خطایی رخ داده است')
      }
    }
    setIsLoading(false)
  }


  return (
    <Modal
      show={show}
      onHide={handleClose}
      keyboard={false}
      style={{ direction: 'rtl', textAlign: 'right' }}
      size='md'
      centered

    >
      <Modal.Header className='bg-danger' style={{ height: '60px' }}>
        <i className='fa fa-trash text-white fs-2  mx-auto'></i>
      </Modal.Header>
      <Modal.Body className='text-center'>
        <div style={{ fontSize: '1rem', minHeight: "60px", display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div className=''>{customer ? customer.companyName : ''}</div>
          <div className='mt-3'>حذف شود ؟</div>
        </div>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-center align-items-center'>
        <Button variant="danger" disabled={isLoading} style={{ width: '80px' }} onClick={deleteCustomerHandler}>حذف</Button>
        <Button variant="secondary" disabled={isLoading} style={{ width: '80px' }} onClick={handleClose}>انصراف</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
